module.exports = __webpack_public_path__ + "static/media/ELS25NG01.ade34cf8.png";